module.exports = __webpack_public_path__ + "img/cloud-drizzle-sun.0ed51098.svg";